import { SignalDispatcher } from 'ste-signals';

export const offerEvents = {
  onUpdated: new SignalDispatcher(),
};
